const chatServiceURL =
  "https://6f16e5f9-2def-4b0a-a380-e5f6cef76e6b-00-1u9sjwqyhenk1.kirk.replit.dev"; // Replit backend URL

/**
 * Fetches a chat token for the given user.
 * @param {string} userId - The ID of the user.
 * @param {boolean} isGuest - Whether the user is a guest.
 * @returns {Promise<{ token: string, userId: string }>} - The user token and ID.
 */
export async function getChatToken(userId, isGuest = true) {
  try {
    const response = await fetch(
      `${chatServiceURL}/services/chatservice/token`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, isGuest }),
      }
    );

    if (!response.ok) {
      throw new Error(`Error fetching token: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getChatToken:", error);
    throw error;
  }
}
